import classnames from 'classnames';
import * as React from 'react';

import './index.scss';

interface IProps {
    direction: 'LEFT' | 'RIGHT',
    classNames?: string;
    isOpen: boolean;
}

export const Arrow: React.SFC<IProps> = ({ isOpen, classNames, direction }) => {
    return (
        <span
            className={classnames(
                'arrow',
                {
                    active: isOpen,
                    direction_left: direction === 'LEFT',
                    direction_right: direction === 'RIGHT'
                },
                classNames
            )}
        />
    );
};
